/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaTrophy } from "react-icons/fa";

import { API } from "@services/http.service";

/**
 * Arka plan rozet bileşeni (Story 5/7). Ana sayfada görünür bir kart YOKTUR;
 * rozetler "Rozetlerim" menüsünden görüntülenir. Bu bileşen mount'ta giriş sayacını
 * tetikler (recordEntry) ve kazanılıp henüz gösterilmemiş bir kutlama varsa modal gösterir.
 *
 * Görünürlük Home'da isComponentActive("ROZET") ile kontrol edilir.
 */
const HomeBadgeStrip = () => {
  const navigate = useNavigate();
  const [celebration, setCelebration] = useState(null);

  useEffect(() => {
    let active = true;

    const loadCelebrations = () =>
      API.get("/badge/tiered/celebrations")
        .then((res) => {
          if (active && res?.isHttpSuccess && res.data?.length) {
            setCelebration(res.data[0]);
          }
        })
        .catch(() => {});

    // Giriş sayacını tetikle, sonra gösterilmemiş kutlamaları çek.
    API.post("/badge/tiered/recordEntry")
      .catch(() => {})
      .finally(loadCelebrations);

    return () => {
      active = false;
    };
  }, []);

  if (!celebration) {
    return null;
  }

  return (
    <CelebrationModal
      celebration={celebration}
      onClose={() => setCelebration(null)}
      onGo={() => navigate("/profile/badges")}
    />
  );
};

const CelebrationModal = ({ celebration, onClose, onGo }) => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1080,
      padding: 16,
    }}
    onClick={onClose}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        maxWidth: 420,
        width: "100%",
        textAlign: "center",
        background: "#fff",
        borderRadius: 16,
        padding: "40px 30px",
        boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
      }}
    >
      <div style={{ fontSize: 64, marginBottom: 12 }}>🎉</div>
      <div style={{ fontSize: 22, fontWeight: 700, color: "#1B5E7B", marginBottom: 6 }}>Tebrikler!</div>
      <div style={{ fontSize: 14, color: "#64748b", marginBottom: 20 }}>{celebration.badgeName || celebration.name} Kazandınız!</div>
      <div
        style={{
          width: 80,
          height: 80,
          borderRadius: "50%",
          margin: "0 auto 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 36,
          border: "4px solid #FFD54F",
          background: "linear-gradient(135deg,#FFF8E1,#FFECB3)",
        }}
      >
        {celebration.imageUrl ? <img src={celebration.imageUrl} alt="" style={{ width: 44, height: 44 }} /> : <FaTrophy color="#F9A825" />}
      </div>
      <div style={{ fontSize: 13, color: "#475569", lineHeight: 1.6, marginBottom: 20 }}>
        {celebration.notificationText || `${celebration.name} rozetini hak ettiniz!`}
      </div>
      <button
        type="button"
        onClick={onGo}
        style={{
          padding: "10px 24px",
          background: "#1B5E7B",
          color: "#fff",
          border: "none",
          borderRadius: 8,
          fontSize: 13,
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Rozetlerimi Gör →
      </button>
    </div>
  </div>
);

export default HomeBadgeStrip;
